/**
 * 任务名称服务
 */
export interface TaskNameService {
    /**
     * 获取任务名称
     * @param taskId 任务ID
     * @returns 任务名称
     */
    getTaskName(taskId: string): Promise<string>;
    /**
     * 设置任务名称
     * @param taskId 任务ID
     * @param taskName 任务名称
     */
    setTaskName(taskId: string, taskName: string): Promise<void>;
}

export const TaskNameService = Symbol('TaskNameService');
